import React, { useEffect, useState } from "react";
import { KyberLogo } from "../KyberLogo";

const BIOS_LINES = [
  "KyberBusiness BIOS v1.0",
  "CPU: Ledger Engine @ 233MHz",
  "Memory Test: 65536K OK",
  "Detecting drives...",
  "  Master: KYBER-BUSINESS-DRIVE     ...OK",
  "Press DEL to enter SETUP",
];

const SESSION_KEY = "kb_boot_played";

export default function BootScreen() {
  // Server/first-paint is always "skip" -> renders null, identical on the client
  // before effects run, so there's no hydration mismatch to guard.
  const [stage, setStage] = useState("skip");
  const [lineCount, setLineCount] = useState(0);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      sessionStorage.setItem(SESSION_KEY, "1");
      return;
    }
    setStage("bios");
  }, []);

  useEffect(() => {
    if (stage !== "bios") return undefined;
    if (lineCount >= BIOS_LINES.length) {
      const t = setTimeout(() => setStage("logo"), 300);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => setLineCount((c) => c + 1), 180);
    return () => clearTimeout(t);
  }, [stage, lineCount]);

  useEffect(() => {
    if (stage !== "logo") return undefined;
    const t = setTimeout(() => {
      sessionStorage.setItem(SESSION_KEY, "1");
      setStage("done");
    }, 1600);
    return () => clearTimeout(t);
  }, [stage]);

  if (stage === "skip" || stage === "done") return null;

  return (
    <div className="win98-boot-overlay" role="status" aria-label="Loading">
      {stage === "bios" && (
        <pre className="win98-boot-bios">
          {BIOS_LINES.slice(0, lineCount).join("\n")}
          <span className="win98-boot-cursor">_</span>
        </pre>
      )}
      {stage === "logo" && (
        <div className="win98-boot-logo">
          <KyberLogo size={140} />
          <div className="win98-boot-progress">
            <div className="win98-boot-progress-fill" />
          </div>
        </div>
      )}
    </div>
  );
}
